import { useFormikContext } from "formik";

import { IAddIncomeForm } from "../../../../config/interfaces";
import { FormField, NumericInputField } from "../../../fields";

const SalarySection89ANonNotifiedForm = () => {
  const { values, errors, touched, setFieldValue, handleBlur } = useFormikContext<IAddIncomeForm>();

  return (
    <section>
      <FormField label="I(e). Income under section 89A - other than notified country" sm={6}>
        <NumericInputField
          showLeftIcon={true}
          name="IncomeUnderSection89AOtherThanNotifiedCountry"
          value={values.IncomeUnderSection89AOtherThanNotifiedCountry}
          onBlur={handleBlur("IncomeUnderSection89AOtherThanNotifiedCountry")}
          onChange={(value) =>
            setFieldValue("IncomeUnderSection89AOtherThanNotifiedCountry", value)
          }
          isInvalid={
            Boolean(errors.IncomeUnderSection89AOtherThanNotifiedCountry) &&
            touched.IncomeUnderSection89AOtherThanNotifiedCountry
          }
          errorMsg={errors.IncomeUnderSection89AOtherThanNotifiedCountry}
        />
      </FormField>
    </section>
  );
};

export default SalarySection89ANonNotifiedForm;
